/* Même halo que la réaffectation Dispatch ; le groupe SVG porte déjà le changement d'échelle. */
@keyframes geotab-sheet-gantt-halo {
  0%, 100% { box-shadow: 0 8px 16px rgba(15, 23, 42, .045); }
  45% {
    box-shadow:
      0 0 0 4px color-mix(in srgb, var(--color-accent) 34%, transparent),
      0 0 0 10px color-mix(in srgb, var(--color-accent) 18%, transparent),
      0 16px 28px color-mix(in srgb, var(--color-accent) 18%, transparent);
  }
  70% {
    box-shadow:
      0 0 0 3px color-mix(in srgb, var(--color-accent) 24%, transparent),
      0 0 0 7px color-mix(in srgb, var(--color-accent) 12%, transparent),
      0 12px 22px color-mix(in srgb, var(--color-accent) 12%, transparent);
  }
}
@media (prefers-reduced-motion: no-preference) {
  .geotab-sheet-gantt-halo { animation: geotab-sheet-gantt-halo .92s ease-in-out 5; }
}
/* Chargement sans comparatif : ligne de lecture qui parcourt le carnet, puis arrivée du Gantt en fondu ; immobiles avec le mouvement réduit. */
@keyframes geotab-sheet-gantt-scan {
  from { transform: translateY(0); }
  to { transform: translateY(var(--scan-distance)); }
}
@keyframes geotab-sheet-gantt-arrive {
  from { opacity: 0; }
}
@media (prefers-reduced-motion: no-preference) {
  .geotab-sheet-gantt-scan { animation: geotab-sheet-gantt-scan 1s ease-in-out infinite; }
  .geotab-sheet-gantt-arrive { animation: geotab-sheet-gantt-arrive .18s ease-out; }
}
/* « Actualisation en cours » : trait qui parcourt le bas de l'en-tête ; immobile avec le mouvement réduit. */
@keyframes geotab-sheet-gantt-refresh {
  from { transform: translateX(-100%); }
  to { transform: translateX(300%); }
}
@media (prefers-reduced-motion: no-preference) {
  .geotab-sheet-gantt-refresh { animation: geotab-sheet-gantt-refresh 1s ease-in-out infinite; }
}
